import { render, staticRenderFns } from "./AnswerQuestion.vue?vue&type=template&id=a7ef179e&scoped=true"
import script from "./AnswerQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestion.vue?vue&type=style&index=0&id=a7ef179e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ef179e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
